import { GoPlus } from "react-icons/go";
import { Button } from "../../../../components/forms";
import { nodept } from "../../../../constant/import";
import { ListPicker } from "../../../../components/generic/ListPicker";
import { usePickerhook } from "../../../../hooks/usePickerhook";
import { Fragment, useState } from "react";
import Switch from "react-switch";
import { countries } from "../../../../constant/data";
import AddHolidayModal from "../../../../components/Modules/Employees/AddHolidayModal";
import useCalendarHook from "../../../../hooks/useCalendarHook";
import { FaRegCalendarDays } from "react-icons/fa6";
import { IoReceipt } from "react-icons/io5";
import AppraisalTemplateItem from "../../../../components/Modules/Appraisal/AppraisalTemplateItem";
import AddAppraisalTempModal from "../../../../components/Modules/Employees/AddAppraisalTempModal";
import useAppraisalTempHook from "../../../../hooks/useAppraisalTempHook";
import { Menu, Transition } from "@headlessui/react";
import { CiEdit } from "react-icons/ci";
import { FiFileMinus } from "react-icons/fi";
import { MdDelete } from "react-icons/md";
import PreviewAppraisalTemplateModal from "../../../../components/Modules/Appraisal/PreviewAppraisalTemplateModal";

export default ({ setshowadddept, leaves, refresh }: any) => {
  const [enablecountryconf, setenablecountryconf] = useState(false);
  const [showadd, setshowadd] = useState(false);
  const weekendpickedhook = usePickerhook();
  const [istricistifeedback, setistricistifeedback] = useState(false);
  const [iscycle, setiscycle] = useState(false);
  const [target, setTarget] = useState("");
  const { orgAppTemplates, getOrgTemplates } = useAppraisalTempHook();

  return (
    <div className="w-full pr-20 pb-4 flex  ">
      <div className={` p-6 bg-white    w-full  rounded-[20px]`}>
        {showadd && (
          <AddAppraisalTempModal
            target={target}
            refresh={getOrgTemplates}
            show={setshowadd}
          />
        )}
        <div className="flex justify-between items-center rounded ">
          <p className="text-textbg font-medium  mb-2 text-[16px]  bg-white">
            Appraisal
          </p>
          <Menu as="div" className={`relative my-2 `}>
            <Menu.Button className="   w-full  ">
              <Button text="Add Template" width={240} onBtnClick={() => {}} />
            </Menu.Button>

            <Transition
              as={Fragment}
              enter="transition ease-out duration-100"
              enterFrom="transform opacity-0 scale-95"
              enterTo="transform opacity-100 scale-100"
              leave="transition ease-in duration-75"
              leaveFrom="transform opacity-100 scale-100"
              leaveTo="transform opacity-0 scale-95"
            >
              <Menu.Items
                onClick={() => {
                  setshowadd(true);
                }}
                className="origin-top-left z-10 absolute left-0 mt-2 rounded-sm shadow-md p-1 bg-white w-full  max-h-[200px] min-w-[180px]   overflow-x-hidden overflow-y-scroll ring-1 ring-black ring-opacity-5 focus:outline-none"
              >
                <Menu.Item>
                  <p
                    onClick={() => {
                      setTarget("org");
                    }}
                    className=" text-xs font-light w-full text-black p-3 m-2 cursor-pointer truncate hover:bg-customGray "
                  >
                    Organization Template
                  </p>
                </Menu.Item>
                <Menu.Item>
                  <p
                    onClick={() => {
                      setTarget("dept");
                    }}
                    className=" text-xs font-light w-full text-black p-3 m-2 cursor-pointer truncate hover:bg-customGray "
                  >
                    Department Template
                  </p>
                </Menu.Item>

                <Menu.Item>
                  <p
                    onClick={async () => {
                      setTarget("pos");
                    }}
                    className=" text-xs font-light w-full text-black p-3 m-2 cursor-pointer truncate hover:bg-customGray "
                  >
                    Position Template
                  </p>
                </Menu.Item>
              </Menu.Items>
            </Transition>
          </Menu>
        </div>

        <div className="px-6 ">
          <p className="font-semibold "> Appraisal Templates</p>

          {orgAppTemplates.map((item) => (
            <AppraisalTemplateItem refresh={getOrgTemplates} item={item} />
          ))}
        </div>
        <div className="px-6 ">
          <div className="w-full flex justify-between">
            <p className="font-semibold ">360 Feedback Template</p>
          </div>
        </div>
        <div className="px-6 ">
          <div className="w-full flex justify-between">
            <p className="font-semibold ">Appraisal Cycle</p>
            <Switch
              checkedIcon={false}
              uncheckedIcon={false}
              offColor="#EAECF5"
              onColor="#CB0E5F"
              className="m-4"
              onChange={async () => {
                setiscycle((prev) => !prev);
              }}
              checked={iscycle}
            />
          </div>

          {iscycle && (
            <div className="flex flex-col gap-6">
              <div className="flex justify-between items-center ">
                <div>
                  <p className="font-semibold text-gray-600 ">
                    Appraisal Timming After Recruitment
                  </p>
                  <p className="text-gray-400 ">
                    Specify months after recruitment for the first appraisal.
                  </p>
                </div>
                <ListPicker
                  hook={weekendpickedhook}
                  notitle
                  title="Interval"
                  list={[]}
                />
              </div>
              <div className="flex justify-between items-center ">
                <div>
                  <p className="font-semibold text-gray-600 ">
                    Recurring Appraisal Timing
                  </p>
                  <p className="text-gray-400 ">
                    Set the frequency of recurring appraisals
                  </p>
                </div>
                <ListPicker
                  hook={weekendpickedhook}
                  notitle
                  title="Interval"
                  list={[]}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
